module.exports = __webpack_public_path__ + "img/zs_8@2x.cf0564aa.png";